<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.97904 2.50391C6.80078 2.57051 6.62547 2.64317 6.45336 2.72162M17.264 13.5882C17.3492 13.4038 17.4277 13.2157 17.4993 13.0243M15.4149 16.1412C15.558 16.0076 15.6963 15.869 15.8295 15.7256M12.7233 17.8142C12.8851 17.7532 13.0443 17.6872 13.201 17.6165M10.1293 18.3322C9.93684 18.3388 9.74309 18.3388 9.55059 18.3322M6.48868 17.6209C6.63935 17.6887 6.79245 17.7521 6.9478 17.8108M3.89305 15.7712C4.00696 15.892 4.1245 16.0092 4.24551 16.1229M2.19317 13.0577C2.25557 13.2224 2.32315 13.3847 2.39569 13.5442M1.67007 10.425C1.66466 10.2516 1.66467 10.0771 1.67007 9.90341M2.18713 7.28486C2.24843 7.12195 2.31479 6.96151 2.38601 6.80374M3.87927 4.56993C3.99982 4.44152 4.12447 4.31701 4.25301 4.19661"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.25 10.0039C11.25 10.6942 10.6903 11.2539 10 11.2539C9.30967 11.2539 8.75 10.6942 8.75 10.0039C8.75 9.31357 9.30967 8.75391 10 8.75391M11.25 10.0039C11.25 9.31357 10.6903 8.75391 10 8.75391M11.25 10.0039H13.3333M10 8.75391V5.00391"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="round"
    />
    <path
      d="M18.3333 10.0042C18.3333 5.40186 14.6023 1.6709 10 1.6709"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="round"
    />
  </svg>
</template>